var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"synchronized-scroll",class:{
    "no-scrollbar" : _vm.noScrollbar,
    "mobile-version": _vm.isMobile
}},[_c('div',{ref:"scroller",staticClass:"scroller"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }